import { EventEmitter, Injectable, Output } from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { apiUrl } from "src/app/global/global";
import { AdminService } from "src/app/services/admin.service";
import { JobApplyComponent } from "../job-apply.component";
import { CongratulationsComponent } from "../../congratulations/congratulations.component";
import swal from "sweetalert2";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root"
})
export class JobApplyService {
  recruiterID: any;
  jobId: string = "";
  jobs: any;
  @Output() onJobAppliedStatusChange = new EventEmitter<boolean>();

  constructor(private api: AdminService, private modalService: BsModalService,
    private router: Router, private toastrService: ToastrService) { }

  openScreeningQuestionModal(jobId: string) {
    this.jobs = jobId;
    if (this.jobs.id) {
      this.jobId = this.jobs.id
    } else {
      this.jobId = this.jobs
    }

    this.api.getDatas(apiUrl._jobDetails + "/" + this.jobId).subscribe((res) => {

      let modifiedScreenQuestionsData = res.data.JobPostAddQuestions.map((x) => this.question(x));
      if (modifiedScreenQuestionsData.length > 0) {
        const initialState = {
          jobId: res.data.JobPost.id,
          screeningQuestions: modifiedScreenQuestionsData
        };
        this.modalService.show(JobApplyComponent, {
          initialState, class: "registerModal", backdrop: "static",
          keyboard: false, animated: true,
        });
      } else {
        this.applyForJob(modifiedScreenQuestionsData, "");
      }
    })
  }

  applyJob(jobId, recruiterID, callback?: any) {

    this.recruiterID = recruiterID;
    console.log("jobId", recruiterID)
    this.jobs = jobId;
    let status: any;
    if (this.jobs.id) {
      this.jobId = this.jobs.id
    } else {
      this.jobId = this.jobs
    }
    let url = this.jobId + `?status=` + 1
    this.api.getDatas(apiUrl._jobDetails + "/" + url).subscribe((res) => {
      let modifiedScreenQuestionsData = res.data.JobPostAddQuestions.map((x) => this.question(x));
      if (modifiedScreenQuestionsData.length > 0) {
        const initialState = {
          jobId: res.data.JobPost.id,
          screeningQuestions: modifiedScreenQuestionsData
        };
        this.modalService.show(JobApplyComponent, {
          initialState, class: "registerModal", backdrop: "static",
          keyboard: false, animated: true,
        });
      } else {
        this.applyForJob(modifiedScreenQuestionsData, "1", () => {
          callback()
        });
      }
    })
  }

  close() {
    this.modalService?.hide();
    this.discardJob()
  }
  discardJob() {
    console.log("this.jobs", this.jobs)
    this.api.postData(apiUrl._jobApplylog, { "jobPostId": this.jobId, "recruiterId": this.recruiterID, "platformType": 0 }).subscribe((x) => {
      this.modalService?.hide();
    });
  }

  applyForJob(modifiedScreenQuestionsData: any, type, callback?: any) {
    let answersRequest = modifiedScreenQuestionsData.filter((x) => x.answer.length > 0);
    this.api.postData(apiUrl._applyJob, { "jobPostId": this.jobId, "response": answersRequest }).subscribe((x) => {
      this.modalService.show(CongratulationsComponent, {
        backdrop: "static",
        keyboard: false,
        animated: true,
        class: "modal-sm addModal"
      });
      this.router.onSameUrlNavigation = "reload";
      callback();
    });
  }

  withdrawJob(jobId: string, callback?: any) {
    swal.fire({
      html: "Are you sure you want to withdraw from the applied job?",
      showCloseButton: false,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: "#EF7E2B",
      cancelButtonColor: "#ffffff",
      confirmButtonText: "Withdraw",
      cancelButtonText: "Cancel",
      reverseButtons: true,
      width: 500
    }).then((result) => {
      if (result.value) {
        this.api.deleteData(apiUrl._applyJob, { "jobPostId": jobId }).subscribe(res => {
          this.toastrService.success("Job withdraw successfully.");
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = "reload";
          this.refreshComponent();
          if(callback)
          callback();
        })
      }
    });
  }

  refreshComponent(){
    this.router.navigate([this.router.url])
  }

  private question(question: any) {
    return {
      "jobPostAddQuestionId": question.id,
      "title": question.screening_question_name || question.title,
      "responseType": question.responseType,
      "answer": ""
    };
  }

}
